import { ProcedureFolderNode } from "@/model/Procedure/ProcedureFolderNode";
import { ProcedureProjectOwner } from "@/model/Procedure/ProcedureProjectOwner";
import { ProcedureToCopyFrom } from "@/model/Procedure/ProcedureToCopyFrom";
import { ProcedureTrainingCompetency } from "@/model/Procedure/ProcedureTrainingCompetency";

export class ProcedureMetaData {
  CompanyId: number;
  Competency: Array<ProcedureTrainingCompetency>;
  Folders: Array<ProcedureFolderNode>;
  ProjectOwners: Array<ProcedureProjectOwner>;
  ProceduresToCopyFrom: Array<ProcedureToCopyFrom>;
}
